"use strict";

angular.module("customer")
.controller("OwnerFormController", function(
    $scope, $state, $stateParams, InvoiceService, PatternService, FlashBag, gettextCatalog, FormError, EMAIL_MAXLENGTH
) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.pattern = PatternService;
    InvoiceService.getOwner($stateParams.invoice_uuid).$promise.then(function onSuccess(data) {
        $scope.showForm = true;
        $scope.partnership = data;
    });

    function submit() {
        $scope.partnership.invoice_uuid = $stateParams.invoice_uuid;
        InvoiceService.inviteOwner($scope.partnership).then(
            function onSuccess() {
                FlashBag.success(gettextCatalog.getString("The invoice link was successfully sent to the owner."), true);
                $state.go("login");
            }
        )
    }

    this.validate = function() {
        $scope.PartnershipForm.$setSubmitted();
        FlashBag.clearAll();

        if ($scope.PartnershipForm.$valid) {
            submit();
        }
        else {
            FormError.focus("PartnershipForm");
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice/invite-owner-form.controller.js
// module id = 913
// module chunks = 0